import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '../button/button.component';
import TYPES from '../../constants/types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-dialog',
  imports: [
    ButtonComponent,
    TranslatePipe
  ],
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {

  dialogRef = inject<DialogRef<{}>>(DialogRef<{}>);
  data = inject(DIALOG_DATA);

  BUTTON_TYPES: any;

  constructor(){
    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  action(action: string){
    this.dialogRef.close({action});
  }

}
